import angular from 'angular';

import MassiaSelectController from './components/massia-select/massia.select.controller';
import MassiaSelectService from './components/massia-select/services/massia.select.service';
import MassiaSelectSupervisorService from './components/massia-select/services/massia.select.supervisor.service';
import MassiaDateController from './components/massia-date/massia.date.controller';
import MassiaDateService from './components/massia-date/services/massia.date.service';
import MassiaOnoffController from './components/massia-onoff/massia.onoff.controller';
import MassiaInputController from './components/massia-input/massia.input.controller';
import MassiaValidateController from './components/massia-validate/massia.validate.controller';
import MassiaValidateService from './components/massia-validate/services/massia.validate.service';

import MassiaSelectTemplete from './components/massia-select/massia.select.html';
import MassiaDateTemplete from './components/massia-date/massia.date.html';
import MassiaInputTemplete from './components/massia-input/massia.input.html';
import MassiaOnOffTemplete from './components/massia-onoff/massia.onoff.html';
import MassiaValidateTemplete from './components/massia-validate/massia.validate.html';

var myScope = {
	ngModel: '=',
	ngChange: '&',
	help: '<?',
	options: '<?',
	config: '<?',
	placeholder: '@',
	onSelect: '&',
	disabled: '<?',
	isMultiligne: '<?',
	nbLines: '<?',
	callbackListReceived: '&?',
	callbackValid: '&?',
	callbackValidAndClose: '&?',
	callbackClose: '&?',
	optionsListe: '<',
	customType: '@',
	api: '=?'
};

angular.module('sharedService', []).factory('SharedDataService', function () {
	const listeners = [];
	var data = {};
	console.info('[SharedDataService] → Service chargé.');
	function setData(key, valueObject) {
		if (data[key] && angular.equals(data[key], valueObject)) {
			return; // Pas de changement, ne pas émettre d'événement
		}
		data[key] = valueObject;

		// notifier tous les abonnés
		listeners.forEach((cb) => cb(key, valueObject));
	}

	function setAllData(dataObject) {
		for (var key in dataObject) {
			if (Object.prototype.hasOwnProperty.call(dataObject, key)) {
				setData(key, dataObject[key]);
			}
		}
	}

	function getAllData() {
		return data;
	}

	function getData(key) {
		return data[key];
	}

	//Normalement obsolète avec le système de subscribe, mais on garde au cas où
	/*function listenData(key, callback) {
            $rootScope.$on(key + 'Changed', function(event, newValue, oldValue) {
                callback(newValue, oldValue);
            });
        }*/

	function subscribe(callback) {
		listeners.push(callback);

		// optionnel : unsubscribe
		return () => {
			const index = listeners.indexOf(callback);
			if (index > -1) listeners.splice(index, 1);
		};
	}

	return {
		setData: setData,
		setAllData: setAllData,
		getData: getData,
		getAllData: getAllData,
		//listenData: listenData,
		subscribe: subscribe
	};
});

angular
	.module('massiaSelect', ['sharedService'])
	.controller('MassiaSelectController', MassiaSelectController)
	.service('MassiaSelectService', MassiaSelectService)
	.service('MassiaSelectSupervisorService', MassiaSelectSupervisorService)
	.directive('massiaSelect', function () {
		return {
			restrict: 'E',
			scope: angular.copy(myScope),
			template: MassiaSelectTemplete,
			controller: 'MassiaSelectController',
			controllerAs: '$ctrl',
			bindToController: true
		};
	});

angular
	.module('massiaDate', ['sharedService'])
	.controller('MassiaDateController', MassiaDateController)
	.service('MassiaDateService', MassiaDateService)
	.directive('massiaDate', function () {
		return {
			restrict: 'E',
			scope: angular.copy(myScope),
			template: MassiaDateTemplete,
			controller: 'MassiaDateController',
			controllerAs: '$ctrl',
			bindToController: true
		};
	});

angular
	.module('massiaOnoff', ['sharedService'])
	.controller('MassiaOnoffController', MassiaOnoffController)
	.directive('massiaOnoff', function () {
		return {
			restrict: 'E',
			scope: angular.copy(myScope),
			template: MassiaOnOffTemplete,
			controller: 'MassiaOnoffController',
			controllerAs: '$ctrl',
			bindToController: true
		};
	});

angular
	.module('massiaInput', ['sharedService'])
	.controller('MassiaInputController', MassiaInputController)
	.directive('massiaInput', function () {
		return {
			restrict: 'E',
			scope: angular.copy(myScope),
			template: MassiaInputTemplete,
			controller: 'MassiaInputController',
			controllerAs: '$ctrl',
			bindToController: true
		};
	});

///////////////////////////////////////////////////////////////////////////////////////////////
/////////                  BOUTON DE VALIDATION DU FORMULAIRE                            //////
///////////////////////////////////////////////////////////////////////////////////////////////

angular
	.module('massiaValidate', ['sharedService'])
	.controller('MassiaValidateController', MassiaValidateController)
	.service('MassiaValidateService', MassiaValidateService)
	.directive('massiaValidate', function () {
		return {
			restrict: 'E',
			scope: angular.copy(myScope),
			transclude: true,
			template: MassiaValidateTemplete,
			controller: 'MassiaValidateController',
			controllerAs: '$ctrl',
			bindToController: true
		};
	});

angular
	.module('formApp', ['massiaSelect', 'massiaDate', 'massiaInput', 'massiaOnoff', 'massiaValidate'])
	.controller('MainController', function () {
		//var ctrl = this;
	})
	.controller('MassiaValidateController', MassiaValidateController)
	.controller('MassiaDateController', MassiaDateController)
	.controller('MassiaSelectController', MassiaSelectController)
	.controller('MassiaInputController', MassiaInputController)
	.controller('MassiaOnOffController', MassiaOnoffController);

export default 'formApp';
